<template>
    <div>
        <!--  BEGIN NAVBAR  -->
        <div class="header-container fixed-top">
            <!-- Banner assinatura vencida -->
            <div v-if="showOverdueBanner" ref="overdueBannerEl" class="overdue-banner">
                <div class="overdue-banner__inner">
                    <div class="overdue-banner__content">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="overdue-banner__icon">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="12" y1="8" x2="12" y2="12"></line>
                            <line x1="12" y1="16" x2="12.01" y2="16"></line>
                        </svg>
                        <span class="overdue-banner__text">
                            Sua assinatura <strong>{{ overdueSubscription?.plan?.name }}</strong> está vencida! Regularize para manter o acesso completo.
                        </span>
                    </div>
                    <div class="overdue-banner__actions">
                        <router-link to="/faturas" class="overdue-banner__btn">Ver faturas</router-link>
                    </div>
                </div>
            </div>
            <header class="header navbar navbar-expand-sm">
                <ul class="navbar-item theme-brand flex-row text-center">
                    <li class="nav-item theme-logo">
                        <router-link :to="brandHomePath">
                            <img src="/src/assets/images/logo-mini.png" class="navbar-logo" alt="logo" style="width: 52px; height: 36px;" />
                        </router-link>
                    </li>
                    <li class="nav-item theme-text">
                        <router-link :to="brandHomePath" class="nav-link" style="font-size: 1em !important;
                        text-align: left;"> 
                            Descomplique sua correção 
                        </router-link>
                    </li>
                </ul>
                <div class="d-none horizontal-menu">
                    <a href="javascript:void(0);" class="sidebarCollapse" data-placement="bottom" @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="feather feather-menu"
                        >
                            <line x1="3" y1="12" x2="21" y2="12"></line>
                            <line x1="3" y1="6" x2="21" y2="6"></line>
                            <line x1="3" y1="18" x2="21" y2="18"></line>
                        </svg>
                    </a>
                </div>
                <div class="navbar-item flex-row ms-md-auto">
                    <a href="/plano" class="badge badge-warning badge-chip badge-custom ms-2 position-relative">
                        <span class="text"> {{ $store.state.auth?.user?.active_subscription?.plan?.name || 'Professor Iniciante' }} </span>
                    </a>
                    <router-link to="/ajuda" target="_blank" rel="noopener noreferrer" class="help-icon ms-2 d-flex align-items-center" title="Central de ajuda">
                        <BaseIcon name="centralAjuda" :size="20" fill="currentColor" stroke="none" />
                    </router-link>
                    <div class="dark-mode d-flex align-items-center">
                        <a v-if="$store.state.dark_mode == 'light'" href="javascript:;" class="d-flex align-items-center" @click="toggleMode('dark')">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-sun"
                            >
                                <circle cx="12" cy="12" r="5"></circle>
                                <line x1="12" y1="1" x2="12" y2="3"></line>
                                <line x1="12" y1="21" x2="12" y2="23"></line>
                                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                                <line x1="1" y1="12" x2="3" y2="12"></line>
                                <line x1="21" y1="12" x2="23" y2="12"></line>
                                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
                            </svg>
                            <span class="ms-2"></span>
                        </a>
                        <a v-if="$store.state.dark_mode == 'dark'" href="javascript:;" class="d-flex align-items-center" @click="toggleMode('system')">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-moon"
                            >
                                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
                            </svg>
                            <span class="ms-2"></span>
                        </a>
                        <a v-if="$store.state.dark_mode == 'system'" href="javascript:;" class="d-flex align-items-center" @click="toggleMode('light')">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-airplay"
                            >
                                <path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path>
                                <polygon points="12 15 17 21 7 21 12 15"></polygon>
                            </svg>
                            <span class="ms-2"></span>
                        </a>
                    </div>

                    <div class="dropdown nav-item notification-dropdown btn-group">
                        <a href="javascript:;" id="ddlnotify" data-bs-toggle="dropdown" aria-expanded="false" class="btn dropdown-toggle btn-icon-only nav-link notification-bell" @click="handleNotificationClick">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-bell"
                            >
                                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                            </svg>
                            <span 
                                v-if="notificacoesStore.unreadCount > 0" 
                                class="notification-badge"
                                :class="{ 
                                    'notification-badge-large': notificacoesStore.unreadCount > 9 && notificacoesStore.unreadCount <= 99,
                                    'notification-badge-extra-large': notificacoesStore.unreadCount > 99
                                }"
                            >
                                {{ notificacoesStore.unreadCount > 99 ? '99+' : notificacoesStore.unreadCount }}
                            </span>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-right notification-dropdown-menu" aria-labelledby="ddlnotify">
                            <!-- Cabeçalho do dropdown -->
                            <li class="notification-header" role="presentation">
                                <div class="d-flex align-items-center justify-content-between px-3 py-2">
                                    <h6 class="mb-0 fw-bold">Notificações</h6>
                                    <span v-if="notificacoesStore.unreadCount > 0" class="notification-count-badge">
                                        {{ notificacoesStore.unreadCount }}
                                    </span>
                                </div>
                            </li>
                            <li role="presentation">
                                <hr class="dropdown-divider m-0" />
                            </li>
                            
                            <!-- Área scrollável das notificações -->
                            <div class="notification-scroll-area">
                                <ul class="notification-list">
                                    <li v-if="notificacoesStore.loading" role="presentation">
                                        <div class="dropdown-item text-center py-4">
                                            <div class="spinner-border spinner-border-sm text-primary" role="status">
                                                <span class="visually-hidden">Carregando...</span>
                                            </div>
                                            <p class="mb-0 mt-2 text-muted small">Carregando notificações...</p>
                                        </div>
                                    </li>
                                    <template v-else-if="notificacoesStore.notifications.length > 0">
                                        <li v-for="notification in notificacoesStore.notifications" :key="notification.id" role="presentation">
                                            <a href="javascript:;" 
                                               class="dropdown-item notification-item" 
                                               :class="{ 'notification-unread': !notification.read_at }"
                                               @click="handleNotificationItemClick(notification)">
                                                <div class="media">
                                                    <div class="media-aside align-self-start">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            stroke-width="2"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                            class="feather feather-file-text"
                                                            :class="{ 'notification-icon-unread': !notification.read_at }"
                                                        >
                                                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                                            <polyline points="14 2 14 8 20 8"></polyline>
                                                            <line x1="16" y1="13" x2="8" y2="13"></line>
                                                            <line x1="16" y1="17" x2="8" y2="17"></line>
                                                            <polyline points="10 9 9 9 8 9"></polyline>
                                                        </svg>
                                                        <!-- Indicador de não lida -->
                                                        <span v-if="!notification.read_at" class="notification-indicator"></span>
                                                    </div>
                                                    <div class="media-body">
                                                        <div class="data-info">
                                                            <h6 :class="{ 'notification-title-unread': !notification.read_at }">
                                                                {{ notification.data?.title || 'Notificação' }}
                                                            </h6>
                                                            <p 
                                                                :class="{ 
                                                                    'notification-message-unread': !notification.read_at,
                                                                    'notification-message-expanded': expandedNotifications[notification.id]
                                                                }"
                                                            >
                                                                {{ notification.data?.message || '' }}
                                                            </p>
                                                            <div class="notification-footer-info">
                                                                <button 
                                                                    v-if="shouldShowExpandButton(notification.data?.message)"
                                                                    @click.stop="toggleNotificationExpand(notification.id)"
                                                                    class="btn-expand-notification"
                                                                    type="button"
                                                                >
                                                                    {{ expandedNotifications[notification.id] ? 'Ver menos' : 'Ver tudo' }}
                                                                </button>
                                                                <small class="text-muted">{{ formatTimeAgo(notification.created_at) }}</small>
                                                            </div>
                                                        </div>
                                                        <div class="icon-status" @click.stop="handleDeleteNotification(notification.id)" title="Remover notificação">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="18"
                                                                height="18"
                                                                viewBox="0 0 24 24"
                                                                fill="none"
                                                                stroke="currentColor"
                                                                stroke-width="2"
                                                                stroke-linecap="round"
                                                                stroke-linejoin="round"
                                                                class="feather feather-x"
                                                            >
                                                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                                                <line x1="6" y1="6" x2="18" y2="18"></line>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                    </template>
                                    <li v-else role="presentation">
                                        <div class="dropdown-item text-center py-4">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="48"
                                                height="48"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                class="feather feather-bell-off text-muted mb-2"
                                                style="opacity: 0.5;"
                                            >
                                                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                                                <path d="M18.63 13A17.89 17.89 0 0 1 18 8A6 6 0 0 0 6 8c0 1.76.58 3.38 1.55 4.7"></path>
                                                <line x1="1" y1="1" x2="23" y2="23"></line>
                                            </svg>
                                            <p class="mb-0 text-muted small">Nenhuma notificação</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            
                            <!-- Rodapé do dropdown -->
                            <template v-if="!notificacoesStore.loading && notificacoesStore.notifications.length > 0">
                                <li role="presentation">
                                    <hr class="dropdown-divider m-0" />
                                </li>
                                <li role="presentation" class="notification-footer">
                                    <a href="javascript:;" class="dropdown-item text-center py-2" @click="handleMarkAllAsRead">
                                        <small class="fw-semibold">Marcar todas como lidas</small>
                                    </a>
                                </li>
                            </template>
                        </ul>
                    </div>

                    <div class="dropdown nav-item user-profile-dropdown btn-group">
                        <a href="javascript:;" id="ddluser" data-bs-toggle="dropdown" aria-expanded="false" class="btn dropdown-toggle btn-icon-only user nav-link">
                            <ProfileAvatar :src="store.state.auth?.user?.profilePic" :name="store.state.auth?.user?.name" alt="avatar" class="avatar-img"/>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-right m-0" aria-labelledby="ddluser">
                            <li role="presentation">
                                <router-link to="/meus-dados" class="dropdown-item">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-user"
                                    >
                                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                        <circle cx="12" cy="7" r="4"></circle>
                                    </svg>
                                   Minha conta
                                </router-link>
                            </li>
                            <li role="presentation">
                                <router-link to="/configuracoes/notificacoes" class="dropdown-item">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-settings"
                                    >
                                        <circle cx="12" cy="12" r="3"></circle>
                                        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33h0A1.65 1.65 0 0 0 9 3.09V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51h0a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v0A1.65 1.65 0 0 0 20.91 9H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
                                    </svg>
                                    Preferências
                                </router-link>
                            </li>
                            <li role="presentation">
                                <router-link to="/faturas" class="dropdown-item">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-file-text"
                                    >
                                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                        <polyline points="14 2 14 8 20 8"></polyline>
                                        <line x1="16" y1="13" x2="8" y2="13"></line>
                                        <line x1="16" y1="17" x2="8" y2="17"></line>
                                        <polyline points="10 9 9 9 8 9"></polyline>
                                    </svg>
                                    Faturas
                                </router-link>
                            </li>
                            <li role="presentation">
                                <router-link to="/auth/login" @click.prevent="logout" class="dropdown-item">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-log-out"
                                    >
                                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                        <polyline points="16 17 21 12 16 7"></polyline>
                                        <line x1="21" y1="12" x2="9" y2="12"></line>
                                    </svg>
                                    Sair
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </header>
        </div>
        <!--  END NAVBAR  -->
        <!--  BEGIN NAVBAR  -->
        <div class="sub-header-container">
            <header class="header navbar navbar-expand-sm">
                <a href="javascript:void(0);" class="sidebarCollapse" data-placement="bottom" @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-menu"
                    >
                        <line x1="3" y1="12" x2="21" y2="12"></line>
                        <line x1="3" y1="6" x2="21" y2="6"></line>
                        <line x1="3" y1="18" x2="21" y2="18"></line>
                    </svg>
                </a>
                <!-- Portal vue/Teleport for Breadcrumb -->
                <div id="breadcrumb" class="vue-portal-target d-flex flex-grow-1 align-items-center min-w-0"></div>
            </header>
        </div>
        <!--  END NAVBAR  -->
        <!--  BEGIN TOPBAR  -->
        <div class="topbar-nav header navbar" role="banner">
            <nav class="topbar">
                <ul class="list-unstyled menu-categories" id="topAccordion">
                    <li class="menu single-menu">
                        <a href="javascript:;" class="dropdown-toggle autodroprown">
                            <div class="">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-home"
                                >
                                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                                </svg>
                                <span>{{ $t('dashboard') }}</span>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-down"
                            >
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </a>
                        <ul class="collapse submenu list-unstyled">
                            <li>
                                <router-link to="/"> {{ $t('sales') }} </router-link>
                            </li>
                            <!-- Rota não utilizada - removida para evitar warnings
                            <li>
                                <router-link to="/inicio">{{ $t('analytics') }}</router-link>
                            </li>
                            -->
                        </ul>
                    </li>

                    <!-- Seção Apps - Rotas não utilizadas - comentada para evitar warnings
                    <li class="menu single-menu">
                        <a href="javascript:;" class="dropdown-toggle">
                            <div class="">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-cpu"
                                >
                                    <rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect>
                                    <rect x="9" y="9" width="6" height="6"></rect>
                                    <line x1="9" y1="1" x2="9" y2="4"></line>
                                    <line x1="15" y1="1" x2="15" y2="4"></line>
                                    <line x1="9" y1="20" x2="9" y2="23"></line>
                                    <line x1="15" y1="20" x2="15" y2="23"></line>
                                    <line x1="20" y1="9" x2="23" y2="9"></line>
                                    <line x1="20" y1="14" x2="23" y2="14"></line>
                                    <line x1="1" y1="9" x2="4" y2="9"></line>
                                    <line x1="1" y1="14" x2="4" y2="14"></line>
                                </svg>
                                <span>{{ $t('apps') }}</span>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-down"
                            >
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </a>
                        <ul class="collapse submenu list-unstyled">
                            <li><router-link to="/apps/chat">Chat</router-link></li>
                            <li><router-link to="/apps/mailbox">Mailbox</router-link></li>
                            <li><router-link to="/apps/todo-list">Todo List</router-link></li>
                            <li><router-link to="/apps/notes">Notes</router-link></li>
                            <li><router-link to="/apps/scrumboard">Scrumboard</router-link></li>
                            <li><router-link to="/apps/contacts">Contacts</router-link></li>

                            <li class="sub-sub-submenu-list">
                                <a href="javascript:;">
                                    Invoice
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-chevron-right"
                                    >
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </a>
                                <ul class="collapse list-unstyled sub-submenu">
                                    <li><router-link to="/apps/invoice/list">List</router-link></li>
                                    <li><router-link to="/apps/invoice/preview">Preview</router-link></li>
                                    <li><router-link to="/apps/invoice/add">Add</router-link></li>
                                    <li><router-link to="/apps/invoice/edit">Edit</router-link></li>
                                </ul>
                            </li>
                            <li><router-link to="/apps/calendar">Calendar</router-link></li>
                        </ul>
                    </li>
                    -->

                    <!-- Seção Components - Rotas não utilizadas - comentada para evitar warnings
                    <li class="menu single-menu">
                        <a href="javascript:;" class="dropdown-toggle">
                            <div class="">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-box"
                                >
                                    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                                    <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                                    <line x1="12" y1="22.08" x2="12" y2="12"></line>
                                </svg>
                                <span>{{ $t('components') }}</span>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-down"
                            >
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </a>
                        <ul class="collapse submenu list-unstyled">
                            <li><router-link to="/components/tabs">Tabs</router-link></li>
                            <li><router-link to="/components/accordions">Accordions</router-link></li>
                            <li><router-link to="/components/modals">Modals</router-link></li>
                            <li><router-link to="/components/cards">Cards</router-link></li>
                            <li><router-link to="/components/carousel">Carousel</router-link></li>
                            <li><router-link to="/components/countdown">Countdown</router-link></li>
                            <li><router-link to="/components/counter">Counter</router-link></li>
                            <li><router-link to="/components/sweetalert">Sweet Alerts</router-link></li>
                            <li><router-link to="/components/timeline">Timeline</router-link></li>
                            <li><router-link to="/components/notifications">Notifications</router-link></li>
                            <li><router-link to="/components/media-object">Media Object</router-link></li>
                            <li><router-link to="/components/list-group">List Group</router-link></li>
                            <li><router-link to="/components/pricing-table">Pricing Tables</router-link></li>
                            <li><router-link to="/components/lightbox"> Lightbox </router-link></li>
                        </ul>
                    </li>
                    -->

                    <!-- Seção UI Kit - Rotas não utilizadas - comentada para evitar warnings
                    <li class="menu single-menu">
                        <a href="javascript:;" class="dropdown-toggle">
                            <div class="">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-zap"
                                >
                                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                                </svg>
                                <span>{{ $t('ui_kit') }}</span>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-down"
                            >
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </a>
                        <ul class="collapse submenu list-unstyled">
                            <li><router-link to="/elements/alerts">Alerts</router-link></li>
                            <li><router-link to="/elements/avatar">Avatar</router-link></li>
                            <li><router-link to="/elements/badges">Badges</router-link></li>
                            <li><router-link to="/elements/breadcrumbs">Breadcrumbs</router-link></li>
                            <li><router-link to="/elements/buttons">Buttons</router-link></li>
                            <li><router-link to="/elements/buttons-group">Button Groups</router-link></li>
                            <li><router-link to="/elements/color-library">Color Library</router-link></li>
                            <li><router-link to="/elements/dropdown">Dropdown</router-link></li>
                            <li><router-link to="/elements/infobox">Infobox</router-link></li>
                            <li><router-link to="/elements/jumbotron">Jumbotron</router-link></li>
                            <li><router-link to="/elements/loader">Loader</router-link></li>
                            <li><router-link to="/elements/pagination">Pagination</router-link></li>
                            <li><router-link to="/elements/popovers">Popovers</router-link></li>
                            <li><router-link to="/elements/progress-bar">Progress Bar</router-link></li>
                            <li><router-link to="/elements/search">Search</router-link></li>
                            <li><router-link to="/elements/tooltips">Tooltips</router-link></li>
                            <li><router-link to="/elements/treeview">Treeview</router-link></li>
                            <li><router-link to="/elements/typography">Typography</router-link></li>
                        </ul>
                    </li>
                    -->

                    <!-- Seção Tables - Rotas não utilizadas - comentada para evitar warnings
                    <li class="menu single-menu">
                        <a href="javascript:;" class="dropdown-toggle">
                            <div class="">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-layout"
                                >
                                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                                    <line x1="3" y1="9" x2="21" y2="9"></line>
                                    <line x1="9" y1="21" x2="9" y2="9"></line>
                                </svg>
                                <span>{{ $t('tables') }}</span>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-down"
                            >
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </a>
                        <ul class="collapse submenu list-unstyled">
                            <li><router-link to="/tables/basic">Basic</router-link></li>
                            <li class="sub-sub-submenu-list">
                                <a href="javascript:;" class="dropdown-toggle">
                                    DataTables
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-chevron-right"
                                    >
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </a>
                                <ul class="collapse list-unstyled sub-submenu">
                                    <li class="sub-sub-sub-submenu-list">
                                        <a href="javascript:;" class="dropdown-toggle">
                                            vue3-datatable
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                class="feather feather-chevron-right"
                                            >
                                                <polyline points="9 18 15 12 9 6"></polyline>
                                            </svg>
                                        </a>
                                        <ul class="collapse list-unstyled sub-sub-submenu">
                                            <li><router-link to="/tables/vue3-datatable/basic">Basic</router-link></li>
                                            <li><router-link to="/tables/vue3-datatable/advance">Advanced</router-link></li>
                                            <li><router-link to="/tables/vue3-datatable/order-sorting">Order Sorting</router-link></li>
                                            <li><router-link to="/tables/vue3-datatable/alt-pagination">Alt. Pagination</router-link></li>
                                            <li><router-link to="/tables/vue3-datatable/search">Search</router-link></li>
                                            <li><router-link to="/tables/vue3-datatable/checkbox">Checkbox</router-link></li>
                                            <li><router-link to="/tables/vue3-datatable/slot">Slot</router-link></li>
                                            <li><router-link to="/tables/vue3-datatable/column-filter">Column Filter</router-link></li>
                                            <li><router-link to="/tables/vue3-datatable/actions">Actions</router-link></li>
                                            <li><router-link to="/tables/vue3-datatable/sticky-header">Sticky Header</router-link></li>
                                            <li><router-link to="/tables/vue3-datatable/column-chooser">Column Chooser</router-link></li>
                                        </ul>
                                    </li>
                                    <li class="sub-sub-sub-submenu-list">
                                        <a href="javascript:;" class="dropdown-toggle">
                                            v3-table
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                class="feather feather-chevron-right"
                                            >
                                                <polyline points="9 18 15 12 9 6"></polyline>
                                            </svg>
                                        </a>
                                        <ul class="collapse list-unstyled sub-sub-submenu">
                                            <li><router-link to="/tables/v3-table/basic">Basic</router-link></li>
                                            <li><router-link to="/tables/v3-table/striped">Striped Table</router-link></li>
                                            <li><router-link to="/tables/v3-table/order-sorting">Order Sorting</router-link></li>
                                            <li><router-link to="/tables/v3-table/multi-column">Multi Column</router-link></li>
                                            <li><router-link to="/tables/v3-table/multiple-tables">Multiple Tables</router-link></li>
                                            <li><router-link to="/tables/v3-table/alt-pagination">Alt. Pagination</router-link></li>
                                            <li><router-link to="/tables/v3-table/custom">Custom</router-link></li>
                                            <li><router-link to="/tables/v3-table/range-search">Range Search</router-link></li>
                                            <li><router-link to="/tables/v3-table/export">Export</router-link></li>
                                            <li><router-link to="/tables/v3-table/live-dom-ordering">Live DOM ordering</router-link></li>
                                            <li><router-link to="/tables/v3-table/miscellaneous">Miscellaneous</router-link></li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    -->

                    <!-- Seção Forms - Rotas não utilizadas - comentada para evitar warnings
                    <li class="menu single-menu">
                        <a href="javascript:;" class="dropdown-toggle">
                            <div class="">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-clipboard"
                                >
                                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                                    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                                </svg>
                                <span>{{ $t('forms') }}</span>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-down"
                            >
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </a>
                        <ul class="collapse submenu list-unstyled">
                            <li><router-link to="/forms/basic">Basic</router-link></li>
                            <li><router-link to="/forms/input-group">Input Group</router-link></li>
                            <li><router-link to="/forms/layouts">Layouts</router-link></li>
                            <li><router-link to="/forms/validation">Validation</router-link></li>
                            <li><router-link to="/forms/input-mask">Input Mask</router-link></li>
                            <li><router-link to="/forms/select2">Select2</router-link></li>
                            <li><router-link to="/forms/touchspin">TouchSpin</router-link></li>
                            <li><router-link to="/forms/checkbox-radio">Checkbox &amp; Radio</router-link></li>
                            <li><router-link to="/forms/switches">Switches</router-link></li>
                            <li><router-link to="/forms/wizards">Wizards</router-link></li>
                            <li><router-link to="/forms/file-upload">File Upload</router-link></li>
                            <li><router-link to="/forms/quill-editor">Quill Editor</router-link></li>
                            <li><router-link to="/forms/markdown-editor">Markdown Editor</router-link></li>
                            <li><router-link to="/forms/date-picker">Date &amp; Range Picker </router-link></li>
                            <li><router-link to="/forms/clipboard">Clipboard</router-link></li>
                        </ul>
                    </li>
                    -->

                    <!-- Seção Pages - Rotas não utilizadas - comentada para evitar warnings
                    <li class="menu single-menu">
                        <a href="javascript:;" class="dropdown-toggle">
                            <div class="">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-file"
                                >
                                    <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                                    <polyline points="13 2 13 9 20 9"></polyline>
                                </svg>
                                <span>{{ $t('pages') }}</span>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-down"
                            >
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </a>
                        <ul class="collapse submenu list-unstyled">
                            <li><router-link to="/pages/helpdesk">Helpdesk</router-link></li>
                            <li><router-link to="/pages/contact-us">Contact Form</router-link></li>
                            <li><router-link to="/pages/faq">FAQ</router-link></li>
                            <li><router-link to="/pages/faq2">FAQ 2</router-link></li>
                            <li><router-link to="/pages/privacy-policy">Privacy Policy</router-link></li>
                            <li><a target="_blank" href="/pages/coming-soon">Coming Soon</a></li>
                            <li><router-link to="/pages/blank-page">Blank Page</router-link></li>
                            <li><router-link to="/pages/sample">Sample Page</router-link></li>

                            <li><router-link to="/users/profile">Profile</router-link></li>
                            <li><router-link to="/users/account-setting">Account Settings</router-link></li>
                            <li class="sub-sub-submenu-list">
                                <a href="javascript:;" class="dropdown-toggle">
                                    Error
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-chevron-right"
                                    >
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </a>
                                <ul class="collapse list-unstyled sub-submenu">
                                    <li><a target="_blank" href="/pages/error404">404</a></li>
                                    <li><a target="_blank" href="/pages/error500">500</a></li>
                                    <li><a target="_blank" href="/pages/error503">503</a></li>
                                    <li><a target="_blank" href="/pages/maintenence">Maintanence</a></li>
                                </ul>
                            </li>
                            <li class="sub-sub-submenu-list">
                                <a href="javascript:;" class="dropdown-toggle">
                                    Login
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-chevron-right"
                                    >
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </a>
                                <ul class="collapse list-unstyled sub-submenu">
                                    <li><a target="_blank" href="/auth/login">Login Cover</a></li>
                                    <li><a target="_blank" href="/auth/login-boxed">Login Boxed</a></li>
                                </ul>
                            </li>
                            <li class="sub-sub-submenu-list">
                                <a href="javascript:;" class="dropdown-toggle">
                                    Register
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-chevron-right"
                                    >
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </a>
                                <ul class="collapse list-unstyled sub-submenu">
                                    <li><a target="_blank" href="/auth/register">Register Cover</a></li>
                                    <li><a target="_blank" href="/auth/register-boxed">Register Boxed</a></li>
                                </ul>
                            </li>

                            <li class="sub-sub-submenu-list">
                                <a href="javascript:;" class="dropdown-toggle">
                                    Password Recovery
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-chevron-right"
                                    >
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </a>
                                <ul class="collapse list-unstyled sub-submenu">
                                    <li><a target="_blank" href="/auth/recuperar-senha">Recover ID Cover</a></li>
                                </ul>
                            </li>

                            <li class="sub-sub-submenu-list">
                                <a href="javascript:;" class="dropdown-toggle">
                                    Lockscreen
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-chevron-right"
                                    >
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </a>
                                <ul class="collapse list-unstyled sub-submenu">
                                    <li><a target="_blank" href="/auth/lockscreen">Unlock Cover</a></li>
                                    <li><a target="_blank" href="/auth/lockscreen-boxed">Unlock Boxed</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    -->

                    <!-- Seção More - Rotas não utilizadas - comentada para evitar warnings
                    <li class="menu single-menu">
                        <a href="javascript:;" class="dropdown-toggle">
                            <div class="">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-plus-circle"
                                >
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <line x1="12" y1="8" x2="12" y2="16"></line>
                                    <line x1="8" y1="12" x2="16" y2="12"></line>
                                </svg>
                                <span>{{ $t('more') }}</span>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-down"
                            >
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </a>
                        <ul class="collapse submenu list-unstyled">
                            <li><router-link to="/dragndrop">Drag and Drop</router-link></li>
                            <li><router-link to="/widgets">Widgets</router-link></li>
                            <li><router-link to="/charts/apex-chart">Charts</router-link></li>
                            <li><router-link to="/font-icons">Font Icons</router-link></li>
                            <li>
                                <a target="_blank" href="https://cork-vue.sbthemes.com"> Documentation </a>
                            </li>
                        </ul>
                    </li>
                    -->
                </ul>
            </nav>
        </div>
        <!--  END TOPBAR  -->
    </div>
</template>

<style scoped>
    /* Badge do plano - usando :deep() para afetar classes do Bootstrap */
    :deep(a.badge-custom),
    :deep(.badge-custom) {
        background: #9b842a !important;
        background: linear-gradient(90deg,rgba(155, 132, 42, 0.67) 0%, rgba(237, 206, 83, 0.75) 100%) !important;
        display: inline-block !important;
        padding: 0 15px !important;
        font-size: 12px !important;
        line-height: 32px !important;
        border-radius: 25px !important;
        cursor: pointer !important;
    }
    
    .header :deep(.avatar-img) {
        width: 30px !important;
        height: 30px !important;
        object-fit: cover;
    }
    
    /* Estilo do ícone de ajuda */
    .help-icon {
        color: #fff;
        transition: all 0.2s ease;
        padding: 6px;
        border-radius: 50%;
        cursor: pointer;
    }
    
    .help-icon:hover {
        color: #fff;
        background-color: rgba(255, 255, 255, 0.1);
        transform: scale(1.1);
    }
    
    .help-icon svg {
        width: 20px;
        height: 20px;
    }
    
    /* Estilização das notificações */
    .notification-item {
        transition: all 0.2s ease;
        cursor: pointer;
        border-radius: 4px;
        margin: 2px 4px;
    }
    
    /* Notificações não lidas */
    .notification-unread {
        background-color: rgba(13, 110, 253, 0.08) !important;
        border-left: 3px solid #0d6efd;
        font-weight: 500;
    }
    
    /* Hover para notificações não lidas */
    .notification-unread:hover {
        background-color: rgba(13, 110, 253, 0.15) !important;
        transform: translateX(2px);
        box-shadow: 0 2px 8px rgba(13, 110, 253, 0.15);
        border-left-width: 4px;
    }
    
    /* Hover para notificações lidas */
    .notification-item:not(.notification-unread):hover {
        background-color: rgba(108, 117, 125, 0.08) !important;
        opacity: 1 !important;
        transform: translateX(2px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }
    
    /* Melhora a transição do ícone no hover */
    .notification-item:hover .feather {
        transform: scale(1.05);
        transition: transform 0.2s ease;
    }
    
    /* Feedback visual no título ao hover */
    .notification-item:hover h6 {
        transition: color 0.2s ease;
    }
    
    /* Indicador de não lida (bolinha azul) */
    .notification-indicator {
        position: absolute;
        top: 0;
        left: 20px;
        width: 8px;
        height: 8px;
        background: #0d6efd;
        border-radius: 50%;
        border: 2px solid #fff;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    }
    
    /* Título da notificação não lida */
    .notification-title-unread {
        font-weight: 700 !important;
        color: #0d6efd !important;
    }
    
    /* Mensagem da notificação não lida */
    .notification-message-unread {
        font-weight: 500 !important;
        color: #212529 !important;
    }
    
    /* Ícone da notificação não lida */
    .notification-icon-unread {
        color: #0d6efd !important;
    }
    
    /* Notificações lidas - mais opacas e com cores mais suaves */
    .notification-item:not(.notification-unread) {
        opacity: 0.7;
    }
    
    .notification-item:not(.notification-unread) h6 {
        font-weight: 400 !important;
        color: #6c757d !important;
    }
    
    .notification-item:not(.notification-unread) p {
        color: #6c757d !important;
    }
    
    .notification-item:not(.notification-unread) .feather {
        color: #adb5bd !important;
    }
    
    .notification-dropdown .icon-status {
        cursor: pointer;
    }
    
    .notification-dropdown .icon-status:hover {
        color: #dc3545;
    }
    
    /* Ajuste para o media-aside ter position relative para o indicador */
    .notification-item .media-aside {
        position: relative;
    }
    
    /* Estilização do badge de notificação */
    .notification-bell {
        position: relative;
    }
    
    .notification-badge {
        position: absolute;
        top: -6px;
        right: -6px;
        background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
        color: #fff;
        border-radius: 50%;
        min-width: 14px;
        height: 14px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 9px;
        font-weight: 700;
        padding: 0 3px;
        box-shadow: 0 1px 3px rgba(220, 53, 69, 0.4), 0 0 0 1.5px rgba(255, 255, 255, 0.8);
        border: 1.5px solid #fff;
        line-height: 1;
        letter-spacing: 0;
        z-index: 10;
        animation: pulse 2s infinite;
        white-space: nowrap;
        box-sizing: border-box;
    }
    
    /* Ajuste para números maiores que 9 e menores que 99 */
    .notification-badge-large {
        min-width: 16px !important;
        height: 14px !important;
        font-size: 8px !important;
        padding: 0 4px !important;
    }
    
    /* Ajuste para 99+ */
    .notification-badge-extra-large {
        min-width: 18px !important;
        height: 14px !important;
        font-size: 7px !important;
        padding: 0 5px !important;
        border-radius: 7px !important;
    }
    
    @keyframes pulse {
        0% {
            transform: scale(1);
            box-shadow: 0 1px 3px rgba(220, 53, 69, 0.3);
        }
        50% {
            transform: scale(1.05);
            box-shadow: 0 2px 5px rgba(220, 53, 69, 0.5);
        }
        100% {
            transform: scale(1);
            box-shadow: 0 1px 3px rgba(220, 53, 69, 0.3);
        }
    }
    
    /* Estilização moderna do dropdown de notificações - usando :deep() para afetar elemento filho do Bootstrap */
    :deep(.notification-dropdown-menu) {
        min-width: 380px !important;
        max-width: 420px !important;
        padding: 0 !important;
        border-radius: 12px !important;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08) !important;
        border: 1px solid rgba(0, 0, 0, 0.08) !important;
        overflow: hidden !important;
        background: #fff !important;
    }
    
    /* Cabeçalho do dropdown */
    :deep(.notification-header) {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: #fff;
        border-radius: 12px 12px 0 0;
        padding: 0 !important;
    }
    
    :deep(.notification-header h6) {
        color: #fff !important;
        font-size: 16px;
        font-weight: 600;
    }
    
    .notification-count-badge {
        background: rgba(255, 255, 255, 0.25);
        backdrop-filter: blur(10px);
        color: #fff;
        padding: 4px 10px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 700;
        min-width: 24px;
        text-align: center;
        border: 1px solid rgba(255, 255, 255, 0.3);
    }
    
    /* Área scrollável */
    :deep(.notification-scroll-area) {
        max-height: 480px;
        overflow-y: auto;
        overflow-x: hidden;
        position: relative;
    }
    
    /* Scrollbar customizado */
    :deep(.notification-scroll-area::-webkit-scrollbar) {
        width: 6px;
    }
    
    :deep(.notification-scroll-area::-webkit-scrollbar-track) {
        background: #f1f1f1;
        border-radius: 10px;
    }
    
    :deep(.notification-scroll-area::-webkit-scrollbar-thumb) {
        background: #c1c1c1;
        border-radius: 10px;
        transition: background 0.2s ease;
    }
    
    :deep(.notification-scroll-area::-webkit-scrollbar-thumb:hover) {
        background: #a1a1a1;
    }
    
    /* Lista de notificações */
    :deep(.notification-list) {
        list-style: none;
        padding: 0;
        margin: 0;
    }
    
    :deep(.notification-list .dropdown-item) {
        padding: 14px 16px !important;
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        transition: all 0.2s ease;
    }
    
    :deep(.notification-list .dropdown-item:last-child) {
        border-bottom: none;
    }
    
    /* Melhoria no espaçamento dos itens */
    .notification-item {
        padding: 14px 16px !important;
        margin: 0 !important;
        border-radius: 0 !important;
    }
    
    .notification-item .media {
        gap: 12px;
    }
    
    .notification-item .media-body {
        flex: 1;
        min-width: 0;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 12px;
    }
    
    .notification-item .media-body .data-info {
        flex: 1;
        min-width: 0;
    }
    
    .notification-item .data-info h6 {
        font-size: 14px;
        line-height: 1.4;
        margin-bottom: 4px;
        word-wrap: break-word;
    }
    
    .notification-item .data-info p {
        font-size: 13px;
        line-height: 1.5;
        margin-bottom: 6px;
        word-wrap: break-word;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        transition: all 0.3s ease;
    }
    
    /* Quando expandido, mostra todo o texto */
    .notification-item .data-info p.notification-message-expanded {
        display: block;
        -webkit-line-clamp: unset;
        line-clamp: unset;
        overflow: visible;
        text-overflow: unset;
    }
    
    /* Botão "Ver tudo" / "Ver menos" */
    .btn-expand-notification {
        background: transparent;
        border: none;
        color: #4361ee;
        font-size: 11px;
        font-weight: 600;
        padding: 0px 0 4px;
        cursor: pointer;
        text-decoration: none;
        transition: color 0.2s ease;
        display: inline-block;
        text-align: left;
    }
    
    .btn-expand-notification:hover {
        color: #2d44d8;
        text-decoration: underline;
    }
    
    .btn-expand-notification:focus {
        outline: none;
        color: #2d44d8;
    }
    
    .notification-item .data-info small {
        font-size: 11px;
    }
    
    /* Container para botão e data */
    .notification-footer-info {
        display: flex;
        flex-direction: column;
        gap: 4px;
        margin-top: 4px;
    }
    
    /* Ícone de remover */
    .notification-item .icon-status {
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.2s ease, transform 0.2s ease, background-color 0.2s ease, visibility 0.2s ease;
        transform: scale(0.85);
        padding: 0px 0px 1px 1px !important;
        border-radius: 6px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        flex-shrink: 0;
        width: 21px;
        height: 21px;
        background-color: transparent;
        color: #6c757d;
        position: relative;
        z-index: 10;
    }
    
    .notification-item:hover .icon-status {
        opacity: 1;
        visibility: visible;
        transform: scale(1);
    }
    
    .notification-item .icon-status:hover {
        color: #dc3545 !important;
        transform: scale(1.2);
    }
    
    .notification-item .icon-status svg {
        width: 16px;
        height: 16px;
        pointer-events: none;
    }
    
    /* Rodapé do dropdown */
    :deep(.notification-footer) {
        background: #f8f9fa;
        border-radius: 0 0 12px 12px;
        padding: 0 !important;
    }
    
    :deep(.notification-footer .dropdown-item) {
        transition: all 0.2s ease;
        color: #495057;
    }
    
    :deep(.notification-footer .dropdown-item:hover) {
        background-color: rgba(13, 110, 253, 0.08) !important;
        color: #0d6efd !important;
    }
    
    /* Estado vazio melhorado */
    :deep(.notification-scroll-area .dropdown-item.text-center) {
        padding: 40px 20px !important;
    }

    /* ── Banner Assinatura Vencida ── */
    .overdue-banner {
        background: #fffbeb;
        border-bottom: 1px solid #f59e0b;
    }

    .overdue-banner__inner {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 6px 16px;
    }

    .overdue-banner__content {
        display: flex;
        align-items: center;
        gap: 8px;
        flex: 1;
        min-width: 0;
    }

    .overdue-banner__icon {
        flex-shrink: 0;
        color: #d97706;
    }

    .overdue-banner__text {
        font-size: 12.5px;
        color: #92400e;
        line-height: 1.35;
    }

    .overdue-banner__text strong {
        font-weight: 700;
    }

    .overdue-banner__actions {
        display: flex;
        align-items: center;
        gap: 6px;
        flex-shrink: 0;
    }

    .overdue-banner__btn {
        display: inline-flex;
        align-items: center;
        padding: 3px 12px;
        font-size: 11.5px;
        font-weight: 600;
        color: #fff;
        background: #d97706;
        border-radius: 5px;
        text-decoration: none;
        white-space: nowrap;
        transition: background 0.15s ease, box-shadow 0.15s ease;
        line-height: 1.6;
    }

    .overdue-banner__btn:hover {
        background: #b45309;
        color: #fff;
        box-shadow: 0 1px 4px rgba(180, 83, 9, 0.3);
    }

    @media (max-width: 576px) {
        .overdue-banner__inner {
            flex-wrap: wrap;
            padding: 8px 12px;
        }
        .overdue-banner__actions {
            margin-left: auto;
        }
    }

</style>

<!-- Estilos globais para modo escuro - sem scoped para funcionar corretamente -->
<style>
    /* Modo escuro */
    .dark .notification-dropdown-menu {
        background: #0e1726 !important;
        border-color: #191e3a !important;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5), 0 2px 8px rgba(0, 0, 0, 0.3) !important;
    }
    
    .dark .notification-header {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    }
    
    .dark .notification-list .dropdown-item {
        border-bottom-color: #191e3a;
        color: #e0e6ed;
    }
    
    .dark .notification-list .dropdown-item.text-muted {
        color: #888ea8 !important;
    }
    
    .dark .notification-item:not(.notification-unread) {
        background: transparent;
    }
    
    .dark .notification-item:not(.notification-unread) h6 {
        color: #888ea8 !important;
    }
    
    .dark .notification-item:not(.notification-unread) p {
        color: #6c757d !important;
    }
    
    .dark .notification-item:not(.notification-unread) .feather {
        color: #4a5568 !important;
    }
    
    .dark .notification-item .data-info h6 {
        color: #e0e6ed;
    }
    
    .dark .notification-item .data-info p {
        color: #bfc9d4;
    }
    
    .dark .btn-expand-notification {
        color: #60a5fa;
    }
    
    .dark .btn-expand-notification:hover {
        color: #93c5fd;
    }
    
    .dark .notification-item .data-info small {
        color: #888ea8 !important;
    }
    
    .dark .notification-unread {
        background-color: rgba(13, 110, 253, 0.15) !important;
        border-left-color: #60a5fa !important;
    }
    
    .dark .notification-unread:hover {
        background-color: rgba(13, 110, 253, 0.25) !important;
    }
    
    .dark .notification-title-unread {
        color: #60a5fa !important;
    }
    
    .dark .notification-message-unread {
        color: #e0e6ed !important;
    }
    
    .dark .notification-icon-unread {
        color: #60a5fa !important;
    }
    
    .dark .notification-item .icon-status {
        color: #888ea8;
    }
    
    .dark .notification-item .icon-status:hover {
        background-color: rgba(220, 53, 69, 0.25) !important;
        color: #f87171 !important;
    }
    
    .dark .notification-scroll-area::-webkit-scrollbar-track {
        background: #1b2e4b;
    }
    
    .dark .notification-scroll-area::-webkit-scrollbar-thumb {
        background: #3b3f5c;
    }
    
    .dark .notification-scroll-area::-webkit-scrollbar-thumb:hover {
        background: #4a5568;
    }
    
    .dark .notification-footer {
        background: #1b2e4b;
        border-top-color: #191e3a;
    }
    
    .dark .notification-footer .dropdown-item {
        color: #e0e6ed;
    }
    
    .dark .notification-footer .dropdown-item:hover {
        background-color: rgba(96, 165, 250, 0.15) !important;
        color: #60a5fa !important;
    }
    
    .dark .notification-item:hover:not(.notification-unread) {
        background-color: rgba(255, 255, 255, 0.05) !important;
    }
    
    .dark .notification-badge {
        border-color: #1f2937;
        box-shadow: 0 1px 3px rgba(220, 53, 69, 0.5), 0 0 0 1.5px rgba(31, 41, 55, 0.9);
    }
    
    .dark .notification-scroll-area .dropdown-item.text-center {
        color: #888ea8;
    }
    
    .dark .notification-scroll-area .dropdown-item.text-center .feather {
        color: #4a5568;
    }
    
    .dark .notification-scroll-area .dropdown-item.text-center .spinner-border {
        border-color: #60a5fa;
        border-right-color: transparent;
    }

    /* ── Banner Assinatura Vencida – Dark ── */
    .dark .overdue-banner {
        background: #1c1407 !important;
        border-bottom-color: #92400e !important;
    }
    .dark .overdue-banner__icon {
        color: #fbbf24 !important;
    }
    .dark .overdue-banner__text {
        color: #fde68a !important;
    }
    .dark .overdue-banner__btn {
        background: #b45309 !important;
        color: #fff !important;
    }
    .dark .overdue-banner__btn:hover {
        background: #d97706 !important;
    }
</style>

<script setup>
    import ProfileAvatar from '@/views/components/ProfileAvatar.vue';
    import BaseIcon from '@/components/icons/BaseIcon.vue';

    import { onMounted, onUnmounted, watch, ref, computed, nextTick } from 'vue';
    import { useStore } from 'vuex';
    import { useRouter } from 'vue-router';
    import { useNotificacoesStore } from '@/stores/notificacoes';
    import { isEducadorDigitalPlan } from '@/utils/educadorDigitalPlan';

    const router = useRouter();
    const store = useStore();
    const notificacoesStore = useNotificacoesStore();

    const overdueBannerEl = ref(null);
    const bannerHeight = ref(0);

    const overdueSubscription = computed(() => store.state.auth?.user?.overdue_subscription);
    const showOverdueBanner = computed(() => !!overdueSubscription.value);

    /** Logo + título: Educador Digital abre o painel dedicado; demais casos, início. */
    const brandHomePath = computed(() => {
        const user = store.state.auth?.user;
        return isEducadorDigitalPlan(user) ? '/dashboard-educador-digital' : '/';
    });

    let bannerObserver = null;

    const applyBannerOffset = (h) => {
        document.documentElement.style.setProperty('--overdue-banner-h', h + 'px');
    };

    const measureBanner = () => {
        const h = overdueBannerEl.value ? overdueBannerEl.value.offsetHeight : 0;
        bannerHeight.value = h;
        applyBannerOffset(h);
    };

    watch(showOverdueBanner, async (val) => {
        if (val) {
            await nextTick();
            measureBanner();
            if (overdueBannerEl.value && !bannerObserver) {
                bannerObserver = new ResizeObserver(measureBanner);
                bannerObserver.observe(overdueBannerEl.value);
            }
        } else {
            bannerHeight.value = 0;
            applyBannerOffset(0);
            if (bannerObserver) {
                bannerObserver.disconnect();
                bannerObserver = null;
            }
        }
    }, { immediate: true });

    // Estado para controlar quais notificações estão expandidas
    const expandedNotifications = ref({});
    
    // Função para verificar se o texto precisa de botão "Ver tudo"
    const shouldShowExpandButton = (message) => {
        if (!message) return false;
        // Considera que precisa de botão se o texto tiver mais de aproximadamente 100 caracteres
        // ou mais de 2 linhas (aproximadamente)
        return message.length > 100;
    };
    
    // Função para alternar o estado expandido de uma notificação
    const toggleNotificationExpand = (notificationId) => {
        expandedNotifications.value[notificationId] = !expandedNotifications.value[notificationId];
    };

    // Função para iniciar o polling apenas como fallback se o WebSocket não estiver disponível
    const iniciarPollingSeAutenticado = () => {
        console.log('iniciarPollingSeAutenticado chamado');
        console.log('Usuário autenticado:', !!store.state.auth?.user);
        console.log('Polling ativo?', notificacoesStore.isPolling);
        console.log('WebSocket ativo?', notificacoesStore.isListening);
        
        // Só inicia o polling se:
        // 1. Usuário está autenticado
        // 2. Polling não está ativo
        // 3. WebSocket NÃO está ativo (polling é apenas fallback)
        if (store.state.auth?.user && !notificacoesStore.isPolling && !notificacoesStore.isListening) {
            console.log('✓ Condições satisfeitas. Iniciando polling como fallback (WebSocket não está disponível)...');
            notificacoesStore.startPolling(30000);
        } else {
            console.log('✗ Condições não satisfeitas para iniciar polling');
            if (!store.state.auth?.user) {
                console.log('  - Razão: Usuário não autenticado');
            }
            if (notificacoesStore.isPolling) {
                console.log('  - Razão: Polling já está ativo');
            }
            if (notificacoesStore.isListening) {
                console.log('  - Razão: WebSocket está ativo (polling não é necessário)');
            }
        }
    };

    // Função para iniciar o listener de WebSocket se o usuário estiver autenticado
    const iniciarListenerSeAutenticado = () => {
        const user = store.state.auth?.user;
        if (user && !notificacoesStore.isListening) {
            const userId = user.id || user.uuid;
            if (userId) {
                console.log('✓ Iniciando listener de notificações em tempo real...');
                notificacoesStore.startListening(userId);
            } else {
                console.warn('⚠️ User ID não encontrado no objeto do usuário');
            }
        }
    };

    onMounted(() => {
        toggleMode();
        measureBanner();
        
        // Tenta iniciar o polling e o listener imediatamente
        console.log('=== Header montado. Verificando autenticação... ===');
        console.log('Usuário autenticado:', store.state.auth?.user);
        
        iniciarPollingSeAutenticado();
        iniciarListenerSeAutenticado();
        
        // Tenta destravar o contexto de áudio no primeiro clique do usuário
        // Isso é necessário devido às políticas de autoplay dos navegadores
        const unlockAudioOnInteraction = () => {
            notificacoesStore.unlockAudioContext();
            // Remove os listeners após primeira interação
            document.removeEventListener('click', unlockAudioOnInteraction);
            document.removeEventListener('touchstart', unlockAudioOnInteraction);
            document.removeEventListener('keydown', unlockAudioOnInteraction);
        };
        
        // Adiciona listeners para destravar o áudio na primeira interação
        document.addEventListener('click', unlockAudioOnInteraction, { once: true });
        document.addEventListener('touchstart', unlockAudioOnInteraction, { once: true });
        document.addEventListener('keydown', unlockAudioOnInteraction, { once: true });
    });

    // Watch para iniciar o polling quando o usuário fizer login
    // immediate: true garante que o watch seja executado imediatamente ao montar o componente
    watch(
        () => store.state.auth?.user,
        (newUser, oldUser) => {
            console.log('=== Watch auth.user disparado ===');
            console.log('Usuário anterior:', !!oldUser);
            console.log('Novo usuário:', !!newUser);
            
            if (newUser) {
                console.log('✓ Usuário autenticado detectado, iniciando polling e listener...');
                iniciarPollingSeAutenticado();
                iniciarListenerSeAutenticado();
            } else {
                console.log('✗ Usuário deslogado, parando polling e listener...');
                notificacoesStore.stopPolling();
                notificacoesStore.stopListening();
            }
        },
        { immediate: true }
    );

    onUnmounted(() => {
        notificacoesStore.stopPolling();
        notificacoesStore.stopListening();
        if (bannerObserver) {
            bannerObserver.disconnect();
            bannerObserver = null;
        }
    });

    const toggleMode = (mode) => {
        window.$appSetting.toggleMode(mode);
    };

    const logout = async () => {
        try {
            // Para o polling e o listener antes de fazer logout
            notificacoesStore.stopPolling();
            notificacoesStore.stopListening();
            notificacoesStore.clear();
            
            await store.dispatch('auth/LogOut');
            router.push({ name: 'login' });
        } catch (error) {
            console.log(error);
            router.push({ name: 'login' });
        }
    };

    /**
     * Formata a data para formato relativo (ex: "há 5 minutos", "há 2 horas")
     */
    const formatTimeAgo = (dateString) => {
        if (!dateString) return '';
        
        const date = new Date(dateString);
        const now = new Date();
        const diffInSeconds = Math.floor((now - date) / 1000);
        
        if (diffInSeconds < 60) {
            return 'agora';
        }
        
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        if (diffInMinutes < 60) {
            return `há ${diffInMinutes} ${diffInMinutes === 1 ? 'minuto' : 'minutos'}`;
        }
        
        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) {
            return `há ${diffInHours} ${diffInHours === 1 ? 'hora' : 'horas'}`;
        }
        
        const diffInDays = Math.floor(diffInHours / 24);
        if (diffInDays < 30) {
            return `há ${diffInDays} ${diffInDays === 1 ? 'dia' : 'dias'}`;
        }
        
        const diffInMonths = Math.floor(diffInDays / 30);
        if (diffInMonths < 12) {
            return `há ${diffInMonths} ${diffInMonths === 1 ? 'mês' : 'meses'}`;
        }
        
        const diffInYears = Math.floor(diffInMonths / 12);
        return `há ${diffInYears} ${diffInYears === 1 ? 'ano' : 'anos'}`;
    };

    /**
     * Handler para quando o dropdown de notificações é aberto
     */
    const handleNotificationClick = async () => {
        // Atualiza as notificações quando o usuário abre o dropdown
        // fetchNotifications() já atualiza o unreadCount junto com as notificações
        try {
            await notificacoesStore.fetchNotifications();
        } catch (error) {
            console.error('Erro ao carregar notificações:', error);
        }
    };

    /**
     * Handler para quando uma notificação é clicada
     */
    const handleNotificationItemClick = async (notification) => {
        // Marca como lida se ainda não estiver lida
        if (!notification.read_at) {
            await handleMarkAsRead(notification.id);
        }
        
        // Abre a URL da ação em uma nova aba se existir
        if (notification.data?.action_url) {
            try {
                // Tenta criar uma URL se for uma URL completa
                const url = new URL(notification.data.action_url);
                // Abre em nova aba
                window.open(url.href, '_blank', 'noopener,noreferrer');
            } catch (e) {
                // Se não for uma URL completa, assume que é um path relativo
                // Constrói a URL completa usando a origem atual
                const fullUrl = window.location.origin + notification.data.action_url;
                window.open(fullUrl, '_blank', 'noopener,noreferrer');
            }
        }
    };

    /**
     * Marca uma notificação como lida
     */
    const handleMarkAsRead = async (notificationId) => {
        try {
            await notificacoesStore.markAsRead(notificationId);
        } catch (error) {
            console.error('Erro ao marcar notificação como lida:', error);
        }
    };

    /**
     * Marca todas as notificações como lidas
     */
    const handleMarkAllAsRead = async () => {
        try {
            await notificacoesStore.markAllAsRead();
        } catch (error) {
            console.error('Erro ao marcar todas as notificações como lidas:', error);
        }
    };

    /**
     * Remove uma notificação
     */
    const handleDeleteNotification = async (notificationId) => {
        try {
            await notificacoesStore.deleteNotification(notificationId);
        } catch (error) {
            console.error('Erro ao remover notificação:', error);
            alert('Erro ao remover notificação. Tente novamente.');
        }
    };
</script>
